import types from '../mutation-types';

// Frozen pristine defaults — reset reads from these, never from the live state.
const DEFAULT_CALL = Object.freeze({
  conversationId: null,
  callId: null,
  contactName: '',
  phone: '',
  status: null,
});
const DEFAULT_UI_FLAGS = Object.freeze({ isOpen: false });
const DEFAULT_INCOMING = Object.freeze({
  conversationId: null,
  callId: null,
  contactName: '',
  phone: '',
  sessionId: null,
});

// Factory so each store instance gets a fresh, independent state and the
// frozen defaults above are never aliased by the live state.
const state = () => ({
  call: { ...DEFAULT_CALL },
  uiFlags: { ...DEFAULT_UI_FLAGS },
  incoming: { ...DEFAULT_INCOMING },
  isRinging: false,
});

export const getters = {
  getCall: $state => $state.call,
  getActiveCall: $state => $state.call,
  getUIFlags: $state => $state.uiFlags,
  getIncoming: $state => $state.incoming,
  getIsRinging: $state => $state.isRinging,
};

export const actions = {
  setActiveCall({ commit }, payload) {
    commit(types.SET_WACALLS_CALL, payload);
    commit(types.SET_WACALLS_CALL_UI_FLAG, { isOpen: true });
  },
  setStatus({ commit }, status) {
    commit(types.SET_WACALLS_CALL_STATUS, status);
  },
  reset({ commit }) {
    commit(types.RESET_WACALLS_CALL);
  },
  setIncoming({ commit }, payload) {
    commit(types.SET_WACALLS_INCOMING, payload);
    commit(types.SET_WACALLS_RINGING, true);
  },
  clearIncoming({ commit }) {
    commit(types.CLEAR_WACALLS_INCOMING);
    commit(types.SET_WACALLS_RINGING, false);
  },
};

export const mutations = {
  [types.SET_WACALLS_CALL]($state, payload) {
    $state.call = { ...$state.call, ...payload };
  },
  [types.SET_WACALLS_CALL_STATUS]($state, status) {
    $state.call = { ...$state.call, status };
  },
  [types.SET_WACALLS_CALL_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.RESET_WACALLS_CALL]($state) {
    $state.call = { ...DEFAULT_CALL };
    $state.uiFlags = { ...DEFAULT_UI_FLAGS };
    $state.incoming = { ...DEFAULT_INCOMING };
    $state.isRinging = false;
  },
  [types.SET_WACALLS_INCOMING]($state, payload) {
    $state.incoming = { ...DEFAULT_INCOMING, ...payload };
  },
  [types.CLEAR_WACALLS_INCOMING]($state) {
    $state.incoming = { ...DEFAULT_INCOMING };
  },
  [types.SET_WACALLS_RINGING]($state, value) {
    $state.isRinging = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
